/* eslint-disable */
import { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { ENTITYNAME, SUBTITLETYPE, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from "../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { EditPageHeader } from "../../components/EditPageHeader";
import { utility } from "../../framework/utility/utilityProvider";
import { ConfirmDeleteAlert } from "../../ConfirmAlert";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import AddRoundButton from "../../framework/forms/helpercomponents/buttons/AddRoundButton";
import BossDialog from "../../components/BossDialog";
import ToastNotification from "../../components/ToastNotification";

const MediaEpisodeSubtitleForm = (props) => {

    const lang = useTranslation();
    const [subtitles, setSubtitles] = useState(props.data ?? []);

    const blankDataItem = {
        File: props.item?.File ?? "",
        SubtitleType: props.item?.SubtitleType ?? { ID: 1, Type: "SRT" },
        lang: props.item?.lang ?? "en"
    };

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [file, setFile] = useState(null);
    const fileRef = useRef(null);
    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        loadCombo();
    }, []);

    const loadCombo = async () => {
        const langRes = await API.getDataLookup(ENTITYNAME.Language, { sort: { SID: 1 } });
        setLanguages(langRes.data);
    }

    const onChange = (e) => {
        if (e.target.name === "fileupload") {
            const selectedFile = e.target.files[0];
            if (!selectedFile) return;
            setFile(selectedFile);
            setDataItem(prev => ({ ...prev, File: selectedFile.name }));
            return;
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    };

    const onSave = () => {
        if (!subtitles || subtitles.length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_atleast_one_subtitle_error_message });
            return;
        }

        const finalData = subtitles.map((sub) => ({
            SubtitleType: { ID: sub.SubtitleType?.ID, Type: sub.SubtitleType?.Type },
            fileName: sub.fileName,
            lang: sub.lang ?? "en"
        }))

        console.log(finalData)
        if (props.onSave) {
            props.onSave(finalData);
        }
        props.onClose();
    };

    const addSubtitleToGrid = (e) => {

        if (e) e.preventDefault();

        if (!dataItem.SubtitleType || Object.keys(dataItem.SubtitleType).length === 0) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_subtitle_type_error_message });
            return;
        }
        if (!dataItem.File) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_file_error_message });
            return;
        }

        const newSubtitle = {
            SubtitleType: dataItem?.SubtitleType,
            fileName: dataItem?.File,
            lang: typeof dataItem?.lang === "object" ? dataItem?.lang?.Description : (dataItem?.lang || "en")
        };

        setSubtitles([...subtitles, newSubtitle]);
        setDataItem(blankDataItem);
        setFile(null);
        if (fileRef.current) {fileRef.current.value = "";}
    };

    const removeSubtitleFromGrid = (index) => {
        const updated = [...(subtitles ?? [])];
        updated.splice(index, 1);
        setSubtitles(updated);
    };

    const MyCommandCell = (props) => (
        <div className="mt-1 ml-2" style={{ display: "flex"}}>
            <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => removeSubtitleFromGrid(props.dataIndex), () => { })} />
        </div>
    )

    return (
        <>
            <BossDialog
                title={lang.subtitles_Dialog_header}
                onClose={props.onClose}
                width={"750px"}
            >
                <div className='row'>
                    <div className="col-12">
                        <EditPageHeader showTitle={false} onSubmit={onSave} onCancel={props.onClose} />
                        <div className="row mt-3 align-items-end g-2">
                            <div className="col-1"style={{ paddingRight : "0px"}}>
                                <AddRoundButton onClick={addSubtitleToGrid} />
                            </div>
                            <div className="col-3" style={{ paddingRight : "5px"}}>
                                <label>{lang.subtitle_type_label} *</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={SUBTITLETYPE}
                                    name="SubtitleType"
                                    textField="Type"
                                    dataItemKey="ID"
                                    value={dataItem.SubtitleType}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-3">
                                <label>{lang.language_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={languages}
                                    name="lang"
                                    textField="Description"
                                    dataItemKey="SID"
                                    value={dataItem.lang}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="d-flex align-items-end gap-2">
                                <div className="flex-grow-1">
                                    <label>{lang.file_label}</label>
                                    <input
                                        name="File"
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={dataItem.File}
                                        onChange={onChange}
                                    />
                                </div>

                                <div>
                                    <label
                                        htmlFor="fileupload"
                                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-success"
                                        style={{ height: "30px", marginBottom: 0, marginLeft : 5 }}
                                    >
                                        <input
                                            ref={fileRef}
                                            type="file"
                                            name="fileupload"
                                            id="fileupload"
                                            className="custom-file-updated-input"
                                            hidden
                                            // accept=".srt,.vtt,.pdf"
                                            onChange={onChange}
                                        />
                                        ...
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row mt-4">
                            <div className="col-12">
                                <Grid data={subtitles} style={{ height: "40vh" }} resizable={true}>
                                    <GridColumn cell={MyCommandCell} width={"55px"} />
                                    <GridColumn field="fileName" title={lang.file_label} />
                                    <GridColumn field="SubtitleType.Type" title={lang.subtitle_type_label} width={"150px"} />
                                    <GridColumn field="lang" title={lang.language_label} />
                                </Grid>
                            </div>
                        </div>
                    </div>
                </div>
            </BossDialog>
        </>
    )
}

export default MediaEpisodeSubtitleForm;